import 'abortcontroller-polyfill/dist/polyfill-patch-fetch'
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './pages/index/App';
import reportWebVitals from './reportWebVitals';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import Cart from './pages/cart/Cart';
import { ConfigProvider } from 'antd';
import Detail from './pages/detail';
import Checkout from './pages/order/checkout';
import rm from './utils/rm';
import Order from './pages/order/order';
import AddressList from './pages/address/list';
import AddressEdit from './pages/address/edit';
import MyOrder from './pages/order/myOrder';
import AppBar, { AppBarTab } from './pages/AppBar';
import Me from './pages/me/Me';
import MyCoupon from './pages/myAssets/myCoupon';
import AfterSaleList from './pages/aftersale/list';
import AfterSaleSubmit from './pages/aftersale/submit';
import AfterSaleDetail from './pages/aftersale/detail';
import MyFav from './pages/myAssets/myFav';

const AppbarTabs: AppBarTab[] = [
  { name: "首页", pageTitle: "IT之家商城", icon: "nav_index", route: "/", tabComponent: <App /> },
  { name: "购物车", icon: "nav_cart", route: "/cart", tabComponent: <Cart withAppBar={true} /> },
  { name: "我", icon: "nav_me", route: "/me", tabComponent: <Me /> }
]


const router = createBrowserRouter([
  ...(AppbarTabs.map((i, index) => {
    return {
      path: i.route,
      element: i.tabComponent
      // <AppBar
      //   tabs={AppbarTabs}
      //   tabIndex={index}>
      // </AppBar>
    }
  })),
  {
    path: "/detail",
    element: <Detail />
  },
  {
    path: "/onlycart",
    element: <Cart />
  },
  {
    path: "/order/checkout",
    element: <Checkout />
  },
  {
    path: "/order/order",
    element: <Order />
  },
  {
    path: "/order/myorder",
    element: <MyOrder />
  },
  {
    path: "/address/list",
    element: <AddressList />
  },
  {
    path: "/address/edit",
    element: <AddressEdit />
  },
  {
    path: "/myassets/mycoupon",
    element: <MyCoupon />
  },
  {
    path: "/myassets/myfav",
    element: <MyFav />
  },
  {
    path: "/aftersale/list",
    element: <AfterSaleList />
  },
  {
    path: "/aftersale/submit",
    element: <AfterSaleSubmit />
  },
  {
    path: "/aftersale/detail",
    element: <AfterSaleDetail />
  }
])

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

rm.ready(() => {
  rm.hideMenus(["navigation", "openBrowser", "refresh", "share"]);
  if (rm.getEnv().app !== "unknown") {
    document.body.classList.add("in-app");
    const themeStyle = document.querySelector("#themeColor");
    if (themeStyle) {
      let safeHeight = rm.getSystemInfoSync()?.systemInfo?.safeAreaBottomInset || 0;
      if (rm.getEnv().platform === "iOS") {
        safeHeight -= 16;
      }
      themeStyle.innerHTML = ":root { --safe-aera-height: " + (safeHeight) + "px;}"
    }
    rm.config({
      pageAttr: {//配置页面外观属性
        textSelectable: true,//关闭页面文字选择、链接点按背景特性。由JS-SDK处理，Native忽略此参数。
        safeAreaEnable: true,//需客户端实现，启用iOS页面安全区域。
        swipeBackEnable: false,//需客户端实现，启用Android右滑返回功能
        disableSwipeBack: true,//需客户端实现，禁用iOS滑动返回手势
        bouncesEnable: true,//需客户端实现，启用页面弹性滚动特性
        disableWebProgressBar: true,//客户端实现，禁用安卓页面加载进度条（无法控制页面初次加载）
        disableWebNavigation: true,//客户端实现，禁用安卓按后退按键时webview接管导航行为（即按后退时直接退出页面）
      }
    })

    var wxTitle = document.title;
    var wxDesc = document.querySelectorAll('[name=description]')[0].getAttribute("content");
    var wxImgUrl = _getAbsolutePath(document.querySelectorAll('[rel=apple-touch-icon]')[0].getAttribute("href"));
    var wxShareUrl = "https://mall.ithome.com?isrmmp=1&hidemenu=1";
    rm.shareConfig(
      {
        title: rm.getEnv().app == "wxmp" ? wxDesc : wxTitle, // ��������
        desc: wxDesc, // ��������
        url: wxShareUrl, // ��������
        imgUrl: wxImgUrl, // ����ͼ��/ͼƬ
      },
      function (res) {
        console.log(res);
      }
    )
    // if (rm.getEnv().platform === "Android") {
    //   rm.showMenus(["addHomeIcon", "share"])
    // }
  }
  root.render(
    <ConfigProvider theme={{ token: { colorPrimary: '#D22222', colorInfo:"#D22222" } }}>
      <React.StrictMode>
        <RouterProvider router={router} />
      </React.StrictMode>
    </ConfigProvider>
  );

})

function _getAbsolutePath(href: string | null) {
  var link = document.createElement("a");
  link.href = href || '';
  return link.href;
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
